import { createClient } from "@supabase/supabase-js";

const SUPABASE_URL = "https://jpsyijpjbiokabaznitk.supabase.co";
const SUPABASE_ANON_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Impwc3lpanBqYmlva2FiYXpuaXRrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzMxMDIxMDQsImV4cCI6MjA4ODY3ODEwNH0.pwBv4oqYwKqPLSFNTYVxmKFfW3Ya_FPy_MkLgW7Za68";

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);
